(function () {
  'use strict';

  document.querySelectorAll('.kkumi-faq-main').forEach(function (root) {
    const sid        = root.dataset.sectionId;
    const workerUrl  = (root.dataset.workerUrl || '').replace(/\/$/, '');
    const voteThanks = root.dataset.voteThanks || 'Thanks for the feedback!';

    const searchInput    = document.getElementById('kkfmSearch-'      + sid);
    const clearBtn       = document.getElementById('kkfmClear-'       + sid);
    const hintEl         = document.getElementById('kkfmHint-'        + sid);
    const countEl        = document.getElementById('kkfmCount-'       + sid);
    const catsEl         = document.getElementById('kkfmCats-'        + sid);
    const navEl          = document.getElementById('kkfmNav-'         + sid);
    const emptyEl        = document.getElementById('kkfmEmpty-'       + sid);
    const expandAllBtn   = document.getElementById('kkfmExpandAll-'   + sid);
    const collapseAllBtn = document.getElementById('kkfmCollapseAll-' + sid);

    // ─── ACCORDION ───────────────────────────────────────────────────────────

    function setItem(item, open) {
      const btn = item.querySelector('.kkfm-qa-item__q');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (window.kkumiAccSetOpen) {
        window.kkumiAccSetOpen(item, item.querySelector('.kkfm-qa-item__a'), open);
      } else {
        item.classList.toggle('is-open', open);
      }
    }
    function openItem(item) { setItem(item, true); }
    function closeItem(item) { setItem(item, false); }

    if (catsEl) {
      catsEl.addEventListener('click', function (e) {
        const btn = e.target.closest('.kkfm-qa-item__q');
        if (!btn) return;
        const item = btn.closest('.kkfm-qa-item');
        if (!item) return;
        if (item.classList.contains('is-open')) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    }

    // ─── EXPAND ALL / COLLAPSE ALL ───────────────────────────────────────────

    function getVisibleItems() {
      if (!catsEl) return [];
      return Array.from(catsEl.querySelectorAll('.kkfm-qa-item:not(.is-hidden)'));
    }

    if (expandAllBtn) {
      expandAllBtn.addEventListener('click', function () {
        getVisibleItems().forEach(openItem);
      });
    }

    if (collapseAllBtn) {
      collapseAllBtn.addEventListener('click', function () {
        getVisibleItems().forEach(closeItem);
      });
    }

    // ─── POPULAR CARDS ───────────────────────────────────────────────────────

    root.querySelectorAll('.kkfm-pop-card').forEach(function (card) {
      card.addEventListener('click', function () {
        const anchor = card.dataset.target;
        if (!anchor || !catsEl) return;

        const target = catsEl.querySelector('[data-anchor="' + anchor + '"]');
        if (!target) return;

        if (target.classList.contains('is-hidden')) {
          if (searchInput) {
            searchInput.value = '';
            runSearch('');
          }
        }

        openItem(target);
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // ─── POPULAR CARDS — show top N, ranked by contact form topic counts ─────

    var popGrid = root.querySelector('.kkfm-popular__grid');
    if (popGrid) {
      var maxVisible = parseInt(popGrid.dataset.popularMax, 10) || 4;
      var allCards   = Array.from(popGrid.querySelectorAll('.kkfm-pop-card'));

      function applyVisibility(orderedCards) {
        orderedCards.forEach(function (card, i) {
          card.classList.toggle('is-hidden', i >= maxVisible);
          popGrid.appendChild(card);
        });
      }

      applyVisibility(allCards);

      if (workerUrl) {
        var topicCards = allCards.filter(function (c) { return c.dataset.contactTopic; });
        if (topicCards.length > 0) {
          var topics      = topicCards.map(function (c) { return c.dataset.contactTopic; });
          var topicsParam = encodeURIComponent(topics.join(','));
          fetch(workerUrl + '/contact-counts?topics=' + topicsParam)
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
              if (!data) return;
              var sorted = allCards.slice().sort(function (a, b) {
                var ca = data[a.dataset.contactTopic] || 0;
                var cb = data[b.dataset.contactTopic] || 0;
                return cb - ca;
              });
              applyVisibility(sorted);
            })
            .catch(function () {});
        }
      }
    }

    // ─── SEARCH ──────────────────────────────────────────────────────────────

    let searchTimer = null;

    function runSearch(query) {
      const q = query.trim().toLowerCase();

      if (!catsEl) return;

      let visibleItems = 0;
      let visibleCats  = 0;
      const allCats = Array.from(catsEl.querySelectorAll('.kkfm-cat'));

      allCats.forEach(function (cat) {
        const items = Array.from(cat.querySelectorAll('.kkfm-qa-item'));
        let catVisible = false;

        items.forEach(function (item) {
          if (!q) {
            item.classList.remove('is-hidden');
            catVisible = true;
            visibleItems++;
            return;
          }
          const qText = (item.querySelector('.kkfm-qa-item__q-text') || {}).textContent || '';
          const aText = (item.querySelector('.kkfm-qa-item__a-body')  || {}).textContent || '';
          const match = qText.toLowerCase().includes(q) || aText.toLowerCase().includes(q);

          if (match) {
            item.classList.remove('is-hidden');
            catVisible = true;
            visibleItems++;
          } else {
            item.classList.add('is-hidden');
          }
        });

        if (catVisible) {
          cat.classList.remove('is-hidden');
          visibleCats++;
        } else {
          cat.classList.add('is-hidden');
        }
      });

      if (emptyEl) {
        if (q && visibleItems === 0) {
          emptyEl.classList.add('is-shown');
        } else {
          emptyEl.classList.remove('is-shown');
        }
      }

      if (hintEl && countEl) {
        const totalItems = parseInt(hintEl.dataset.total, 10) || 0;
        const totalCats  = parseInt(hintEl.dataset.cats,  10) || 0;
        countEl.textContent = q ? visibleItems : totalItems;
        const catSpan = hintEl.querySelectorAll('span')[1];
        if (catSpan) catSpan.textContent = q ? visibleCats : totalCats;
      }

      if (clearBtn) {
        clearBtn.classList.toggle('is-shown', q.length > 0);
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(function () {
          runSearch(searchInput.value);
        }, 150);
      });

      searchInput.addEventListener('search', function () {
        if (!searchInput.value) runSearch('');
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (searchInput) {
          searchInput.value = '';
          searchInput.focus();
        }
        runSearch('');
      });
    }

    // ─── DEEP LINKS ──────────────────────────────────────────────────────────
    // /pages/faq#<item id> (the kkfaq-… id on each answer; Support links replies to answers this way) opens
    // that answer and brings it into view, on load and when the hash changes. A search that hides the answer
    // is cleared first. A hash that names no answer on this page does nothing.

    function hashItem() {
      let id = '';
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (e) { return null; }
      const item = id ? document.getElementById(id) : null;
      return item && !item.hidden && catsEl && catsEl.contains(item) && item.classList.contains('kkfm-qa-item') ? item : null;
    }

    function openFromHash(smooth) {
      const item = hashItem();
      if (!item) return;
      if (item.classList.contains('is-hidden') || (item.closest('.kkfm-cat') || item).classList.contains('is-hidden')) {
        if (searchInput) searchInput.value = '';
        runSearch('');
      }
      openItem(item);
      const calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      item.scrollIntoView({ behavior: smooth && !calm ? 'smooth' : 'auto', block: 'start' });
    }

    openFromHash(false);
    window.addEventListener('hashchange', function () { openFromHash(true); });

    // ─── SCROLL-SPY ──────────────────────────────────────────────────────────

    if (navEl && catsEl && 'IntersectionObserver' in window) {
      const navLinks = Array.from(navEl.querySelectorAll('.kkfm-nav__link'));

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          const catId = entry.target.id;
          navLinks.forEach(function (link) {
            link.classList.toggle('is-active', link.dataset.cat === catId);
          });
        });
      }, {
        rootMargin: '-80px 0px -55% 0px',
        threshold: 0
      });

      catsEl.querySelectorAll('.kkfm-cat').forEach(function (cat) {
        observer.observe(cat);
      });
    }

    // ─── VOTING ──────────────────────────────────────────────────────────────

    const VOTE_NS = 'kkfm_voted_';

    function hasVoted(itemId) {
      try { return !!localStorage.getItem(VOTE_NS + itemId); } catch (e) { return false; }
    }

    function recordVote(itemId, direction) {
      try { localStorage.setItem(VOTE_NS + itemId, direction); } catch (e) {}
    }

    function getStoredVote(itemId) {
      try { return localStorage.getItem(VOTE_NS + itemId); } catch (e) { return null; }
    }

    // Restore already-voted state on page load
    root.querySelectorAll('.kkfm-vote').forEach(function (voteEl) {
      const itemId    = voteEl.dataset.voteItem;
      if (!hasVoted(itemId)) return;
      const direction = getStoredVote(itemId);
      const picked    = voteEl.querySelector('[data-vote="' + direction + '"]');
      if (picked) picked.classList.add('is-picked');
      voteEl.querySelectorAll('.kkfm-vote__btn').forEach(function (b) { b.disabled = true; });
      const labelEl = voteEl.querySelector('.kkfm-vote__label');
      if (labelEl) labelEl.textContent = voteThanks;
    });

    // Fetch vote counts on load.
    // ?kkadmin=TOKEN switches to the admin endpoint, which returns both
    // up and down counts and reveals no-vote counts inline on the page.
    // The token is a read-only counts credential for the vote worker. To
    // keep it out of browser history/referrers/logs, it is moved into
    // sessionStorage and stripped from the URL on first load.
    if (workerUrl) {
      const voteEls = Array.from(root.querySelectorAll('.kkfm-vote[data-vote-item]'));
      if (voteEls.length > 0) {
        const voteIds  = voteEls.map(function (el) { return el.dataset.voteItem; }).join(',');
        const votePage = encodeURIComponent(window.location.pathname);
        let adminToken = null;
        try {
          const params = new URLSearchParams(window.location.search);
          const urlToken = params.get('kkadmin');
          if (urlToken) {
            sessionStorage.setItem('kkumi:kkadmin', urlToken);
            params.delete('kkadmin');
            const query = params.toString();
            history.replaceState(null, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
          }
          adminToken = sessionStorage.getItem('kkumi:kkadmin');
        } catch (e) {}

        const countsUrl = workerUrl + (adminToken ? '/admin/counts' : '/counts') + '?page=' + votePage + '&items=' + encodeURIComponent(voteIds);
        const fetchOpts = adminToken ? { headers: { 'Authorization': 'Bearer ' + adminToken } } : {};

        fetch(countsUrl, fetchOpts)
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (!data) return;

            voteEls.forEach(function (voteEl) {
              const itemId = voteEl.dataset.voteItem;
              if (!data[itemId]) return;
              const up = data[itemId].up;
              if (up != null) {
                const upEl = voteEl.querySelector('[data-vote="up"] .kkfm-vote__count');
                if (upEl) upEl.textContent = up > 0 ? up : '';
              }
              if (adminToken) {
                const down = data[itemId].down;
                if (down != null) {
                  const downEl = voteEl.querySelector('[data-vote="down"] .kkfm-vote__count');
                  if (downEl) downEl.textContent = down > 0 ? down : '';
                }
              }
            });

            // Sort answers within each category by yes-vote count, highest first
            if (catsEl) {
              // A deep-linked answer that is on screen keeps its place while the lists reorder around it.
              const anchor = hashItem();
              const before = anchor ? anchor.getBoundingClientRect() : null;
              const onScreen = before && before.bottom > 0 && before.top < window.innerHeight;
              catsEl.querySelectorAll('.kkfm-qa__list').forEach(function (list) {
                const items = Array.from(list.querySelectorAll('.kkfm-qa-item'));
                items.sort(function (a, b) {
                  const aVote = a.querySelector('.kkfm-vote[data-vote-item]');
                  const bVote = b.querySelector('.kkfm-vote[data-vote-item]');
                  const aUp = aVote && data[aVote.dataset.voteItem] ? (data[aVote.dataset.voteItem].up || 0) : 0;
                  const bUp = bVote && data[bVote.dataset.voteItem] ? (data[bVote.dataset.voteItem].up || 0) : 0;
                  return bUp - aUp;
                });
                items.forEach(function (item) { list.appendChild(item); });
              });
              if (onScreen) window.scrollBy(0, anchor.getBoundingClientRect().top - before.top);
            }
          })
          .catch(function () {});
      }
    }

    // Vote click handler
    root.querySelectorAll('.kkfm-vote').forEach(function (voteEl) {
      voteEl.addEventListener('click', function (e) {
        const btn = e.target.closest('.kkfm-vote__btn');
        if (!btn) return;

        const itemId    = voteEl.dataset.voteItem;
        const direction = btn.dataset.vote;

        if (hasVoted(itemId)) return;

        recordVote(itemId, direction);

        btn.classList.add('is-picked');
        voteEl.querySelectorAll('.kkfm-vote__btn').forEach(function (b) { b.disabled = true; });

        if (direction === 'up') {
          const countEl = btn.querySelector('.kkfm-vote__count');
          if (countEl) {
            const current = parseInt(countEl.textContent, 10) || 0;
            countEl.textContent = current + 1;
          }
        }

        const labelEl = voteEl.querySelector('.kkfm-vote__label');
        if (labelEl) labelEl.textContent = voteThanks;

        if (workerUrl) {
          fetch(workerUrl + '/vote', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ item: itemId, direction: direction, page: window.location.pathname })
          })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
              if (!data) return;
              if (direction === 'up' && data.up != null) {
                const countEl = voteEl.querySelector('[data-vote="up"] .kkfm-vote__count');
                if (countEl) countEl.textContent = data.up > 0 ? data.up : '';
              }
            })
            .catch(function () {});
        }
      });
    });

  });

})();
